<template id="Carte_grise">
	<div>
		<Modele id="Carte_grise"/>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Carte_grise',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Immatriculation/Carte_grise.vue